import { UserCompany } from '@company/const';
import { StateUtils } from '@spartacus/core';
import { USER_COMPANIES_ENTITY } from '../company-state';

export const LOAD_USER_COMPANIES = '[Company] Load User Companies';
export const LOAD_USER_COMPANIES_SUCCESS = '[Company] Load User Companies Success';
export const LOAD_USER_COMPANIES_FAIL = '[Company] Load User Companies Fail';
export const RESET_USER_COMPANIES = '[Company] Reset User Companies';

export class LoadUserCompanies extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_USER_COMPANIES;

  constructor() {
    super(USER_COMPANIES_ENTITY);
  }
}

export class LoadUserCompaniesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_USER_COMPANIES_SUCCESS;

  constructor(public payload: UserCompany[]) {
    super(USER_COMPANIES_ENTITY);
  }
}

export class LoadUserCompaniesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_USER_COMPANIES_FAIL;

  constructor() {
    super(USER_COMPANIES_ENTITY);
  }
}

export class ResetUserCompanies extends StateUtils.LoaderResetAction {
  readonly type = RESET_USER_COMPANIES;

  constructor() {
    super(USER_COMPANIES_ENTITY);
  }
}

export type MyAccountActions =
  | LoadUserCompanies
  | LoadUserCompaniesSuccess
  | LoadUserCompaniesFail
  | ResetUserCompanies;
